// @flow
import React, { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from '@finect/front-core/Routes';
import { NotFound } from '@finect/tabular-components/NotFound';
import { Datalayer } from '@finect/front-gtm';
import { help } from '../../data';

type Props = {
  toggleModal: Function,
  match: Object
};

export const Help = ({ toggleModal, ...rest }: Props) => (
  <Switch>
    {help.map((route, index) => (
      <Route
        key={index}
        exact={route.exact}
        path={route.path}
        render={props => (
          <Fragment>
            <Datalayer id="Scene" type="ready" params={{ pageType: 'advisersArticle', pageId: props.match.url }} />
            <Datalayer id="Scene" type="pageType" params={{ pageType: 'advisersArticle', pageId: props.match.url }} />

            {React.createElement(route.component, { toggleModal, ...props })}
          </Fragment>
        )}
      />
    ))}
    <Redirect {...rest} exact from="/asesores/ayuda" to={help[0].path} status={301} withSPA/>
    <Route render={props => <NotFound actionText="Volver a asesores" redirectPath="/asesores" {...props} />} />
  </Switch>
);
